var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center ml-5"},[(_vm.checked)?_c('div',[_c('input',{attrs:{"type":"checkbox","checked":""}})]):_c('div',[_c('input',{attrs:{"type":"checkbox"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }